import React from 'react'
import './ServiciosLoading.css'
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
export default function ServiciosLoading() {
    return (
        <div>

            <Swiper
                effect={'coverflow'}
                grabCursor={true}
                slidesPerView={'auto'}
                id="cardsServicio"
            >
                <SwiperSlide id="butonLoading">

                </SwiperSlide>
                <SwiperSlide id="butonLoading">

                </SwiperSlide>
                <SwiperSlide id="butonLoading">

                </SwiperSlide>

                <SwiperSlide id="butonLoading">

                </SwiperSlide>
                <SwiperSlide id="butonLoading">

                </SwiperSlide>
                <SwiperSlide id="butonLoading">

                </SwiperSlide>
                <SwiperSlide id="butonLoading">

                </SwiperSlide>
                <SwiperSlide id="butonLoading">

                </SwiperSlide>

                <SwiperSlide id="butonLoading">

                </SwiperSlide>
                <SwiperSlide id="butonLoading">

                </SwiperSlide>
            </Swiper>
            <Swiper
                effect={'coverflow'}
                grabCursor={true}
                slidesPerView={'auto'}
                id="cardsServicio"
            >
                <SwiperSlide id="cardServicioLoading">

                </SwiperSlide>
                <SwiperSlide id="cardServicioLoading">

                </SwiperSlide>
                <SwiperSlide id="cardServicioLoading">

                </SwiperSlide>

                <SwiperSlide id="cardServicioLoading">

                </SwiperSlide>
                <SwiperSlide id="cardServicioLoading">

                </SwiperSlide>

            </Swiper>
            <Swiper
                effect={'coverflow'}
                grabCursor={true}
                slidesPerView={'auto'}
                id="cardsServicio"
            >
                <SwiperSlide id="cardServicioLoading">

                </SwiperSlide>
                <SwiperSlide id="cardServicioLoading">

                </SwiperSlide>
                <SwiperSlide id="cardServicioLoading">

                </SwiperSlide>

                <SwiperSlide id="cardServicioLoading">

                </SwiperSlide>
                <SwiperSlide id="cardServicioLoading">

                </SwiperSlide>

            </Swiper>
        </div>
    )
}
